import { FC } from 'react';

import * as S from './CardChip.styles';

interface CardChipProps {
  label: string;
  dataCy: string;
  isLabelClipped?: boolean;
  isMobile?: boolean;
}

export const CardChip: FC<CardChipProps> = ({
  label,
  dataCy,
  isLabelClipped = false,
  isMobile = false
}) => {
  return (
    <S.Chip data-cy={dataCy}>
      <S.Label
        $isClipped={isLabelClipped}
        variant={isMobile ? 'caption3' : 'caption1'}
      >
        {label}
      </S.Label>
    </S.Chip>
  );
};
